/**
 *
 * @module mediaThumbnailLink
 *
 */

import Check from 'check-types';

import Exception from './../exception/entry';

const InvalidArgumentException = Exception.InvalidArgumentException;

const {
    nonEmptyString,
    nonEmptyObject,
    object
} = Check.assert;

/**
 *
 * @class MediaThumbnailLink
 *
 */
export default class MediaThumbnailLink {

    /**
     *
     * @param {Object} options
     * @param {String} options.href
     * @param {String} options.rel
     * @param {String} options.method
     * @param {Object} [options.headers]
     *
     */
    constructor(options) {

        const errorMessage = {
            ctor: 'MediaThumbnailLink(options)',
            get options() {
                return `${this.ctor} options should be a non-empty Object`;
            },
            get href() {
                return `${this.ctor} options.href should be a String with length`;
            },
            get rel() {
                return `${this.ctor} options.rel should be a String with length`;
            },
            get method() {
                return `${this.ctor} options.method should be a String with length`;
            },
            get headers() {
                return `${this.ctor} options.headers should be an Object`;
            }
        };

        nonEmptyObject(options, errorMessage.options, InvalidArgumentException);

        const { href, rel, method, headers } = options;

        nonEmptyString(href, errorMessage.href, InvalidArgumentException);
        nonEmptyString(rel, errorMessage.rel, InvalidArgumentException);
        nonEmptyString(method, errorMessage.method, InvalidArgumentException);

        if (Check.assigned(headers)) {
            object(headers, errorMessage.headers, InvalidArgumentException);
        }

        /**
         *
         * @access public
         * @type {String}
         * @desc href for a given thumbnail presentation
         *
         */
        this.href = href;

        /**
         *
         * @access public
         * @type {String}
         * @desc The name of the relationship - a HATEOAS header
         *
         */
        this.rel = rel;

        /**
         *
         * @access public
         * @type {String}
         * @desc the method used to fetch the thumbnail presentation - should always be GET
         *
         */
        this.method = method;

        /**
         *
         * @access public
         * @type {Object|undefined}
         * @desc custom headers for this thumbnail service - will be merged with headers from the SDK config
         *
         */
        this.headers = headers;

    }

}



// WEBPACK FOOTER //
// ./src/services/media/mediaThumbnailLink.js